<scope-ui-table
  tableClass="fees-table nested shrunk-table"
  [loggedInUser]="authService.loggedInUser"
  [unmappedData]="parent.thirdPartyCosts | orderBy: 'order'"
  [displayedColumns]="columns || scopeElementsService.thirdPartyCostColumns"
  [parentEntity]="parent"
  [level]="level"
  [headerExpandable]="false"
  [noSort]="true"
  [noPagination]="true"
  [noPreferences]="true"
  [showToggleMenu]="false"
  [convertCurrency]="config?.currency"
  [enableDragging]="config?.isEditable"
  [(disableDragging)]="scopeElementsService.disableDragging"
  (updateScopeTpc)="updateTpc($event)"
  (orderChange)="onOrderChange($event)">
</scope-ui-table>
